module.exports = __webpack_public_path__ + "static/media/default_collection.f6833a7f.jpeg";